
































































































































































































































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import {ChartCardDashboardWings, PieChart} from 'wings-ui-components';
import {Action, Getter} from "vuex-class";
import {DateTime} from 'luxon'
import {notifyError} from "@/utils/notify-helper";

@Component({components: { ChartCardDashboardWings, PieChart }})
export default class Dashboard extends Vue {
  @Getter("transports") transports: any;

  @Action("getTransports") actionGetTransports: any;
  @Action("getTemplates") actionGetTemplates: any;
  @Action("getBlacklists") actionGetBlacklists: any;
  @Action("getAddressBooks") actionGetAddressBooks: any;
  @Action("getDistributions") actionGetDistributions: any;
  @Action("getStatisticGroup") actionGetStatisticGroup: any;

  private distributions: any =  {
    PAYMENT_WAITING: 0,
    IN_PROGRESS: 0,
    STOPPED: 0,
    ON_MODERATION: 0,
    FINISHED: 0,
  }
  private templates: any = {
    SMS: null, Call: null, Email: null, Push: null, Viber: null, WhatsApp: null, Custom: null
  }
  private addressBooks: any = {
    count: 0,
    contacts: 0,
  }
  private blacklists: any = {
    count: 0,
    contacts: 0,
  }
  private stats: any = {
    SMS: null, Call: null, Email: null, Push: null, Viber: null, WhatsApp: null, Custom: null
  }
  private chartData: any[] = []

  private todayDate = DateTime.local().toISODate()
  private yesterdayDate = DateTime.local().plus({day: -1}).toISODate()

  private transportColors: any = {
    SMS: '#d92626', Call: '#32c5e9', Email: '#fc9f7f', Push: '#fddb5c', Viber: '#e7bcf3', WhatsApp: '#9fe6b8', Custom: '#228B22', 'Mail Notify': '#37a2da'
  }

  async created() {
    try {
      await this.actionGetTransports();
      this.getDistributions();
      this.getTemplates();
      this.getAddressBooks();
      this.getBlacklists();
      this.getStatistics();
    } catch(error) {
      notifyError(error);
    }
  }

  async getDistributions() {
    const res = await this.actionGetDistributions({page_size: 1000000000});
    res.data.forEach((item:any) => {
      if (item.status in this.distributions) {
        this.distributions[item.status]++;
      }
    })
  }

  async getTemplates() {
    this.transports.forEach(async (transport: string) => {
      const templates = await this.actionGetTemplates({transport: transport});
      this.templates[transport] = templates ? templates.length : 0
    });
  }

  async getAddressBooks() {
    const res = await this.actionGetAddressBooks();
    this.addressBooks.count = res.data.length
    this.addressBooks.contacts = res.data.reduce((accumulator:number, currentValue:any) => accumulator + currentValue.contacts, 0)
  }

  async getBlacklists() {
    const res = await this.actionGetBlacklists();
    this.blacklists.count = res.data.length
    this.blacklists.contacts = res.data.reduce((accumulator:number, currentValue:any) => accumulator + currentValue.contacts, 0)
  }

  async getStatistics() {
    const filter = {
      message_direction: 'mt',
      group_by: 'day',
      date_from: DateTime.local().startOf('month').toISO(),
      date_to: DateTime.local().endOf('month').toISO(),
    }
    this.transports.forEach(async (transport: string) => {
      const res = await this.actionGetStatisticGroup({transport, filter})
      const data = this.getTransportStat(transport, res.data)

      this.stats[transport] = data
      if (data?.month?.count) this.chartData.push({name: transport, value: data.month.count, itemStyle: { color: this.transportColors[transport] }})
    });
  }

  getTransportStat(transport:string, data: any) {
    let month: any
    let today: any
    let yesterday: any

    today = yesterday = month = {count: 0, price: 0, duration: '00:00:00'}

    if (!data.messages) return null

    const todayItem = data?.messages?.find((item: any)=> item.date === this.todayDate)
    if (todayItem) today = {
      count: todayItem.total,
      price: Number(todayItem.partner_price)
    }

    const yesterdayItem = data?.messages?.find((item: any)=> item.date === this.yesterdayDate)
    if (yesterdayItem) yesterday = {
      count: yesterdayItem.total,
      price: Number(yesterdayItem.partner_price)
    }

    month = {
      count: data?.messages_summary?.total,
      price: data?.messages_summary?.partner_price
    }

    if (transport == 'Call') {
      if (todayItem) today.duration = todayItem.duration
      if (yesterdayItem) yesterday.duration = yesterdayItem.duration
      month.duration = data.messages_summary?.duration
    }

    return {transport, today, yesterday, month}
  }
}
